import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from 'process';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class SiteEquipmentLayoutPlanService {

  constructor(private http: HttpClient) { }

  getSiteEquipmentLayoutPlan(siteId, planId): Observable<any> {
    return this.http.get(environment.appUrl + 'sites/' +siteId+'/equipment-layout-plans/' + planId, {observe: 'body', withCredentials: true});
  }

  uploadFile(file): Observable<any> {
    var formData = new FormData();
    formData.append('media', file);
    return this.http.post(environment.appUrl + 'media/upload', formData, {observe: 'body', withCredentials: true});
  }
  create(siteId, form): Observable<any> {
    return this.http.post(environment.appUrl + 'sites/'+ siteId+'/equipment-layout-plans', form, {observe: 'body', withCredentials: true})
  }

  edit(siteId, itemId,form): Observable<any> {
    return this.http.put(environment.appUrl + 'sites/'+ siteId+'/equipment-layout-plans/' + itemId, form, {observe: 'body', withCredentials: true})
  }

  getProjects(siteId): Observable<any> {
    return this.http.get(environment.appUrl + 'projects/sites/' + siteId, {observe: 'body', withCredentials: true});
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/site/site-equipment-layout-plan/site-equipment-layout-plan.service.ts